@if (!isMobile) {
<div class="room-list-header flex-shrink-0" style="height:48.5px;">
    <h5 class="fw-bold mb-0 ms-2 text-uppercase text-secondary">Rooms - {{rooms().length}}</h5>
</div>
<nav class="flex-grow-1 p-2 overflow-auto d-flex flex-column">
    @for (arena of rooms(); track arena.guid) {
    <a href="#" class="room-item d-flex align-items-center text-decoration-none"
        [class.active]="arena.guid === selectedArenaId()" [class]="'room-status-' + arena.status"
        [class.large-avatar-item]="largeImageArenas()[arena.guid]"
        (click)="$event.preventDefault(); selectArena(arena.guid)" (dblclick)="join(arena.guid)">
        @if (largeImageArenas()[arena.guid]) {
        <div class="room-banner-container">
            <img [src]="arena.avatarURL || '/images/logo_1_2.png'" class="room-banner-img" alt="avatar" (load)="onImageLoad($event, arena.guid)">
            <span class="status-dot" [class]="'status-dot-' + arena.status"></span>
        </div>
        <div class="room-details mt-2 w-100">
            <div class="d-flex align-items-center justify-content-between mb-1">
                <div class="fw-bold d-flex align-items-center gap-1 text-warning text-truncate">
                    <span class="text-truncate">{{ arena.title }}</span>
                    @if (arena.status === 'locked') {
                    <i class="bi bi-lock-fill text-warning small"></i>
                    } @else if (arena.status === 'ingame') {
                    <i class="bi bi-swords text-danger small"></i>
                    }
                </div>
                <div class="small text-white bg-dark px-2 py-0.5 rounded-pill border border-secondary flex-shrink-0"
                    style="font-size: 0.8rem;">
                    {{ arena.onlineUsers }}/16
                </div>
            </div>
            @if (arena.description || arena.motd) {
            <div class="small text-muted mb-2 text-wrap"
                style="font-size: 0.85rem; max-height: 48px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
                [title]="arena.description || arena.motd">
                {{ arena.description || arena.motd }}
            </div>
            }
            <button class="btn btn-outline-danger btn-sm w-100 fw-bold mt-1"
                (click)="$event.preventDefault(); join(arena.guid)">Join</button>
        </div>
        } @else {
        <div class="d-flex flex-column align-items-center me-3 flex-shrink-0" style="width: 48px;">
            <div class="position-relative">
                <img [src]="arena.avatarURL || '/images/logo_1_2.png'" class="rounded-circle object-fit" width="48" height="48" alt="avatar"
                    (load)="onImageLoad($event, arena.guid)">
                <span class="status-dot" [class]="'status-dot-' + arena.status"></span>
            </div>
            <div class="small text-white mt-1 text-center" style="font-size: 1rem;">{{ arena.onlineUsers }}/16
            </div>
        </div>
        <div class="flex-grow-1 text-truncate">
            <div class="fw-bold d-flex align-items-center gap-1 text-warning">
                <span>{{ arena.title }}</span>
                @if (arena.status === 'locked') {
                <i class="bi bi-lock-fill text-warning small"></i>
                } @else if (arena.status === 'ingame') {
                <i class="bi bi-swords text-danger small"></i>
                }
            </div>
            @if (arena.description || arena.motd) {
            <div class="small text-muted text-truncate mb-1" [title]="arena.description || arena.motd">{{
                arena.description || arena.motd }}</div>
            }
            <button class="btn btn-outline-danger mt-1 w-100"
                (click)="$event.preventDefault(); join(arena.guid)">Join</button>
        </div>
        }
    </a>
    } @empty {
    <div class="empty-room-list d-flex flex-column align-items-center justify-content-center text-center p-4 my-auto">
        <i class="bi bi-door-open text-muted opacity-50 mb-2" style="font-size: 2.5rem;"></i>
        <p class="text-muted fw-semibold mb-0">Be the first to create a room!</p>
    </div>
    }
</nav>
<div class="flex-shrink-0 w-100 text-center">
    <button class="btn btn-danger m-0 p-3 rounded-0 rounded-bottom-end fw-bold w-100" data-bs-toggle="modal"
        data-bs-target="#createRoomModal" [title]="isGameInstalled() ? 'Create Room' : 'Game installation required to create a room'"
        [disabled]="!isGameInstalled()">
        <i class="bi bi-plus-lg me-1"></i>
        Create Room
    </button>
</div>
} @else {
<div class="offcanvas offcanvas-end text-light" tabindex="-1" id="arenaListOffcanvas"
    aria-labelledby="arenaListOffcanvasLabel" style="background-color: #222; border-left: 1px solid #333;">
    <div class="offcanvas-body p-0 d-flex flex-column h-100">
        <div class="room-list-header d-flex align-items-center flex-shrink-0">
            <h5 class="fw-bold mb-0 ms-2 text-uppercase text-secondary">Rooms - {{rooms().length}}</h5>
            <button type="button" class="btn btn-outline-secondary border-0 ms-auto" data-bs-dismiss="offcanvas"
                aria-label="Close">
                <i class="bi bi-arrow-bar-right fs-5"></i>
            </button>
        </div>
        <nav class="flex-grow-1 p-2 overflow-auto d-flex flex-column">
            @for (arena of rooms(); track arena.guid) {
            <a href="#" class="room-item d-flex align-items-center text-decoration-none"
                [class.active]="arena.guid === selectedArenaId()" [class]="'room-status-' + arena.status"
                [class.large-avatar-item]="largeImageArenas()[arena.guid]"
                (click)="$event.preventDefault(); selectArena(arena.guid)" (dblclick)="join(arena.guid)">
                @if (largeImageArenas()[arena.guid]) {
                <div class="room-banner-container">
                    <img [src]="arena.avatarURL || '/images/logo_1_2.png'" class="room-banner-img" alt="avatar"
                        (load)="onImageLoad($event, arena.guid)">
                    <span class="status-dot" [class]="'status-dot-' + arena.status"></span>
                </div>
                <div class="room-details mt-2 w-100">
                    <div class="d-flex align-items-center justify-content-between mb-1">
                        <div class="fw-bold d-flex align-items-center gap-1 text-warning text-truncate">
                            <span class="text-truncate">{{ arena.title }}</span>
                            @if (arena.status === 'locked') {
                            <i class="bi bi-lock-fill text-warning small"></i>
                            } @else if (arena.status === 'ingame') {
                            <i class="bi bi-swords text-danger small"></i>
                            }
                        </div>
                        <div class="small text-white bg-dark px-2 py-0.5 rounded-pill border border-secondary flex-shrink-0"
                            style="font-size: 0.8rem;">
                            {{ arena.onlineUsers }}/16
                        </div>
                    </div>
                    @if (arena.description || arena.motd) {
                    <div class="small text-muted mb-2 text-wrap"
                        style="font-size: 0.85rem; max-height: 48px; overflow: hidden; text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical;"
                        [title]="arena.description || arena.motd">
                        {{ arena.description || arena.motd }}
                    </div>
                    }
                    <button class="btn btn-outline-danger btn-sm w-100 fw-bold mt-1"
                        (click)="$event.preventDefault(); join(arena.guid)" data-bs-dismiss="offcanvas">Join</button>
                </div>
                } @else {
                <div class="d-flex flex-column align-items-center me-3 flex-shrink-0" style="width: 48px;">
                    <div class="position-relative">
                        <img [src]="arena.avatarURL || '/images/logo_1_2.png'" class="rounded-circle object-fit" width="48" height="48"
                            alt="avatar" (load)="onImageLoad($event, arena.guid)">
                        <span class="status-dot" [class]="'status-dot-' + arena.status"></span>
                    </div>
                    <div class="small text-secondary mt-1 text-center" style="font-size: 0.75rem;">{{ arena.onlineUsers
                        }}/16</div>
                </div>
                <div class="flex-grow-1 text-truncate">
                    <div class="fw-bold d-flex align-items-center gap-1 text-warning">
                        <span>{{ arena.title }}</span>
                        @if (arena.status === 'locked') {
                        <i class="bi bi-lock-fill text-warning small"></i>
                        } @else if (arena.status === 'ingame') {
                        <i class="bi bi-swords text-danger small"></i>
                        }
                    </div>
                    @if (arena.description || arena.motd) {
                    <div class="small text-muted text-truncate mb-1" [title]="arena.description || arena.motd">{{
                        arena.description || arena.motd }}</div>
                    }
                    <button class="btn btn-outline-danger mt-1 w-100"
                        (click)="$event.stopPropagation(); join(arena.guid)" data-bs-dismiss="offcanvas">Join</button>
                </div>
                }
            </a>
            } @empty {
            <div class="empty-room-list d-flex flex-column align-items-center justify-content-center text-center p-4 my-auto">
                <i class="bi bi-door-open text-muted opacity-50 mb-2" style="font-size: 2.5rem;"></i>
                <p class="text-muted fw-semibold mb-0">Be the first to create a room!</p>
            </div>
            }
        </nav>
        <div class="flex-shrink-0 w-100 text-center">
            <button class="btn btn-danger m-0 p-3 rounded-0 rounded-bottom-end fw-bold w-100" data-bs-toggle="modal"
                data-bs-target="#createRoomModal" [title]="isGameInstalled() ? 'Create Room' : 'Game installation required to create a room'"
                [disabled]="!isGameInstalled()">
                <i class="bi bi-plus-lg me-1"></i>
                Create Room
            </button>
        </div>
    </div>
</div>
}